/**
 * "What we do" tabs (About page + healthcare Why Choose Us): activate on click or hover.
 */
(function () {
    function initWhatWeDoTabs() {
        const tabsContainers = document.querySelectorAll('.about-what-we-do');
        tabsContainers.forEach(container => {
            const tabs = container.querySelectorAll('.what-we-do-tab');
            const visualItems = container.querySelectorAll('.what-we-do-image');

            tabs.forEach((tab) => {
                const activateTab = function () {
                    const index = this.getAttribute('data-service-index');

                    tabs.forEach(t => t.classList.remove('active'));
                    visualItems.forEach(v => v.classList.remove('active'));

                    this.classList.add('active');

                    const targetVisual = container.querySelector(`.what-we-do-image[data-service-index="${index}"]`);
                    if (targetVisual) {
                        targetVisual.classList.add('active');
                    }
                };

                tab.addEventListener('click', activateTab);
                tab.addEventListener('mouseenter', activateTab);
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initWhatWeDoTabs);
    } else {
        initWhatWeDoTabs();
    }
})();
